module.exports = __webpack_public_path__ + "static/media/bateria_sprawna.064b2691.svg";